import { useEffect, useState } from "react"
import { useMealTypeQueryParams, useResetMealState } from "../hooks"
import { useAppSelector } from "app/hooks"
import { useSetPageTitle } from "libs/ga"
import { useNavigate } from "react-router-dom"
import {
  useCheckShouldShowTutorial,
  useIsTutorialShowed,
} from "features/onboarding/hooks"
import PATHS from "router/paths"
import BeforeScanning from "./BeforeScaning"
import ScanningResult from "./ScaningResult"
import NotFound from "./NotFound"
import { useUserPlan } from "features/payment/hooks"
import { checkHasAIEntitlement } from "utils"
import FullPageLoading from "components/Layouts/FullPageLoading"
import ScanFailed from "./ScanFailed"

const ScanMeal = () => {
  useSetPageTitle("AI Food Scanner")
  useResetMealState()

  const mealTypeQueryParams = useMealTypeQueryParams()
  const { isTutorialShowed } = useIsTutorialShowed()

  const {
    isShowTutorial,
    checkShowTutorialLoading,
    isRevalidatedShouldShowTutorial,
  } = useCheckShouldShowTutorial()

  const { userPlan } = useUserPlan()
  const entitlements = userPlan?.entitlements

  const [checkingAIScanEntitlement, setCheckingAIScanEntitlement] = useState(
    () => {
      const hasAIScanningEntitlement = checkHasAIEntitlement(entitlements ?? [])

      return !hasAIScanningEntitlement
    },
  )

  const navigate = useNavigate()

  const backToDiary = () => {
    navigate(PATHS.app.root)
  }

  useEffect(() => {
    if (entitlements) {
      const hasAIScanningEntitlement = checkHasAIEntitlement(entitlements)

      if (hasAIScanningEntitlement) {
        setCheckingAIScanEntitlement(false)
      } else {
        backToDiary()
      }
    }
  }, [entitlements])

  useEffect(() => {
    const shouldRedirectToTutorial =
      !isTutorialShowed &&
      !checkShowTutorialLoading &&
      isRevalidatedShouldShowTutorial &&
      isShowTutorial === true

    if (shouldRedirectToTutorial) {
      navigate(`${PATHS.app.meal.tutorial}${mealTypeQueryParams}`)
    }
  }, [
    isShowTutorial,
    checkShowTutorialLoading,
    isRevalidatedShouldShowTutorial,
  ])

  const step = useAppSelector((state) => state.meal.step)

  const checkTutorialLoading = isShowTutorial && checkShowTutorialLoading

  if (checkingAIScanEntitlement || checkTutorialLoading) {
    return <FullPageLoading />
  }

  if (step === "scan-failed") {
    return <ScanFailed />
  }

  if (step === "not-found") {
    return <NotFound />
  }

  if (step === "scan-result") {
    return <ScanningResult />
  }

  return <BeforeScanning />
}

export default ScanMeal
